import {GenericService, ResultType} from '@/shared/xhttp';
import {BoisType} from '@/models';

export class BoisTypeService extends GenericService<BoisType> {
}